import React from "react";

export default function Layout({ children }) {
  React.useEffect(() => {
    document.body.className = "bg-zinc-950 text-zinc-400 antialiased selection:bg-zinc-800 selection:text-zinc-100";
  }, []);

  return (
    <div className="min-h-screen relative font-['Inter',system-ui,sans-serif]">
      {/* Subtle grain/noise background if desired, but minimalism usually avoids it. We'll leave it pure black/zinc */}
      <style>{`
        /* Smooth Scrolling */
        html {
          scroll-behavior: smooth;
        }

        /* Clean Scrollbar */
        ::-webkit-scrollbar {
          width: 8px;
        }
        ::-webkit-scrollbar-track {
          background: transparent;
        }
        ::-webkit-scrollbar-thumb {
          background: #27272a; /* zinc-800 */
          border-radius: 4px;
        }
        ::-webkit-scrollbar-thumb:hover {
          background: #3f3f46; /* zinc-700 */
        }
        
        .nav-link {
          transition: all 0.2s ease;
        }
        .nav-link:hover, .nav-link.active {
          color: #f4f4f5; /* zinc-100 */
        }
        .nav-indicator {
          transition: all 0.2s ease;
          width: 2rem;
          background-color: #3f3f46; /* zinc-700 */
        }
        .nav-link:hover .nav-indicator, .nav-link.active .nav-indicator {
          width: 4rem;
          background-color: #f4f4f5; /* zinc-100 */
        }
      `}</style>
      
      {children}
    </div>
  );
}